// extracted by mini-css-extract-plugin
export var skills = "Skills-module--skills--iBc6z";
export var skills__wrap = "Skills-module--skills__wrap--igiW6";
export var skills__title = "Skills-module--skills__title--oeQTC";
export var skills__radar_wrap = "Skills-module--skills__radar_wrap--90ROa";
export var card_line = "Skills-module--card_line--2c5e6";
export var card_line__item = "Skills-module--card_line__item---MQL0";